<template>
  <v-container fluid>

    <!-- Table search & filters -->
    <v-layout row wrap justify-space-between class="submissions-table-filters">
      <v-flex align-start xs6 md3 lg3 xl2>
        <v-text-field
            solo-inverted
            flat
            label="Search"
            prepend-icon="search"
            v-model="search"
            clearable
          ></v-text-field>
      </v-flex>
      <v-flex align-end xs5 md2>
        <v-select
          label="Status"
          :items="statuses"
          item-text="text"
          item-value="value"
          v-model="selectedStatus"
          prepend-icon="filter_list">
        </v-select>
      </v-flex>
    </v-layout>
    <!-- /Table search & filters -->

    <v-layout>
      <v-flex xs12 class="text-xs-center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
          v-if="loading">
        </v-progress-circular>
      </v-flex>
    </v-layout>

    <!-- SUBMISSIONS TABLE -->
    <v-data-table
      style="opacity:0.95;"
      v-if="!loading"
      :headers="headers"
      :items="filteredItems"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      class="elevation-2 submissions-data-table"
      :search="search"
    >
   
      <template slot="items" slot-scope="props">
        <tr>
          <td @click.stop="openSubmission(props.item)" class="text-xs-left" v-for="column in headers" v-bind:key="column.value">
            <v-avatar v-if="column.value=='user' && props.item.user!==0" size="20" class="mr-1">
                <img :src="users[props.item.user].picUrl">
            </v-avatar>
            
            <v-icon v-if="column.value=='status' && props.item.status==1" small color="green">alarm_add</v-icon>
                
            {{ getColumnValue(props.item, column.key, column.value) }}
              
          </td>  
        </tr>
      </template>
      

      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
      
    </v-data-table>
    <!-- /SUBMISSIONS TABLE -->









    <!-- SINGLE SUBMISSION -->
    <v-dialog v-if="submissionIndex !== -1"
          v-model="submissionDialog"
          fullscreen
          transition="slide-x-reverse-transition"
          scrollable
    >
   <div style="width:100%; height:100%;">
    <v-card class="dialogue-back">

            <!-- header toolbar -->
            <v-toolbar color="primary">
              <v-btn icon class="white--text" @click.native="closeSubmission">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title class="white--text">Vehicle Submission</v-toolbar-title>
              <!-- <v-subtitle>{{ currentSubmission.dateSubmitted }}</v-subtitle> -->
              <v-spacer></v-spacer>

               <span v-if="submissionUsername()">Last update: {{ convertDate(submission.updated) }}</span>
               <span class="mr-4" v-if="submissionUsername()">&nbsp;&nbsp;by {{ submissionUsername() }}</span>
            
              <v-menu 
              bottom
              origin="top center"
              transition="scale-transition"
              >
              
               <v-chip slot="activator" class="mr-2" color="white" text-color="black"> 
                
                  <v-avatar size="32">
                    <v-progress-circular size="24" :rotate="-90" :value="statuses[tempSubmissionStatus].progress" :color="statuses[tempSubmissionStatus].color"></v-progress-circular>
                  </v-avatar>
                 

                <strong>{{ statuses[tempSubmissionStatus].text }}</strong>
                
                  <v-avatar class="ml-4" style="margin-right:-12px;" size="32">
                    <img v-if="submission.user" :src="users[submission.user].picUrl">
                  </v-avatar>
                 
                
              </v-chip>

             
              <v-list light>
                
                <v-list-tile
                v-for="(status, i) in statuses"
                :key="i"
                @click="updateSubmissionStatus(i)"
                v-if="status.value">
                  <v-list-tile-title>{{ status.text }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
             
              
              <v-toolbar-items>
                <v-btn dark flat @click.native="saveSubmission(true)">Save</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <!-- /header toolbar -->
      
            <!-- /dialog content -->
            <v-container grid-list-xl fluid>
              
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <!-- Vehicle Details -->
                  <v-card>

                    <v-carousel v-if="submission.images.length>1"
                      
                      height="240"
                      hide-delimiters
                    >
                      <v-carousel-item
                        v-for="(item,i) in submission.images"
                        :key="i"
                        :src="item.url"
                      ></v-carousel-item>
                    </v-carousel>

                    <v-img v-else max-height="240" :src="submission.images[0].url">
                          <v-layout
                            slot="placeholder"
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-layout>
                    </v-img>  
                
                    <v-card-title primary-title>
                      <div>
                        <h3 class="headline mb-0"><strong>{{ submission.make }}</strong> {{ submission.model }}</h3>
                        <div class="grey--text pb-1">{{ submission.vehicle.description }}</div>
                      </div>
                    </v-card-title>
                       
                    <v-divider></v-divider>

                    <v-subheader>Body</v-subheader>
                    <div class="pb-3 pl-2 pr-2">
                      <v-chip>
                        <v-avatar>
                          <v-icon class="ml-2">directions_car</v-icon>
                        </v-avatar>
                        {{ submission.vehicle.body }}
                      </v-chip>
                      <v-chip>
                        <v-avatar class="grey darken-2 text--lighten-4"><strong>{{ submission.vehicle.doors }}</strong></v-avatar>
                            Doors
                      </v-chip>
                      <v-chip>
                        <v-avatar :class="submission.vehicle.colour">
                          <v-icon class="ml-2">color_lens</v-icon>
                        </v-avatar>
                          {{ submission.vehicle.colour }}
                      </v-chip>
                    </div>

                    <v-divider></v-divider>
                          
                    <v-subheader>Engine</v-subheader>
                    <div class="pb-3 pl-2 pr-2">
                      <v-chip>
                        <strong>Size&nbsp;</strong>{{ submission.vehicle.cc }}
                      </v-chip>

                      <v-chip>
                        <v-avatar>
                          <v-icon class="ml-2">local_gas_station</v-icon>
                        </v-avatar>
                        {{ submission.vehicle.fuel }}
                      </v-chip>

                      <v-chip>
                        <v-avatar>
                          <v-icon class="ml-2">settings_applications</v-icon>
                        </v-avatar>
                        {{ submission.vehicle.transmission }}
                      </v-chip>
                    </div>
                            
                    <v-divider></v-divider>
                    
                    <v-subheader>Registration</v-subheader>
                    <div class="pb-3 pl-2 pr-2">
                      <v-chip color="yellow" style="color:black;">
                        <!-- <v-avatar>
                          <v-icon>account_circle</v-icon>
                        </v-avatar> -->
                        <strong>{{ submission.reg }}</strong>
                      </v-chip>
                    </div>
                            
                  </v-card>
                  <!-- /Vehicle details -->

                <div class="mt-3">
                  <v-alert
                    :value="true"
                    outline
                    type="success"
                    color="accent"
                  >
                    <strong>Submitted:</strong> {{ convertDate(submission.created) }}
                  </v-alert>
                  <small style="color:#333333;">UID: {{ submission.uid }}</small>
                </div>

              </v-flex>

              <v-flex xs12 sm8>
                  
                    <div style="background:transparent;">
                <!-- TABS -->
               
                  <v-tabs
                    slot="extension"
                    v-model="tabs"
                    icons-and-text
                    color="transparent"
                    height="100"
                    grow
                    show-arrows
                  >
                    <v-tabs-slider></v-tabs-slider>
                    
                    <v-tab href="#submission-tabs-1" class="primary--text">
                      Condition
                      <v-icon>directions_car</v-icon>
                    </v-tab>
            
                    <!-- <v-tab href="#submission-tabs-2" class="primary--text">
                      History
                      <v-icon>history</v-icon>
                    </v-tab> -->
            
                    <v-tab href="#submission-tabs-3" class="primary--text">
                      Customer
                      <v-icon>account_box</v-icon>
                    </v-tab>

                    <v-tab href="#submission-tabs-4" class="primary--text">
                      Notes
                      <v-icon>assignment</v-icon>
                    </v-tab>

                    <v-tab href="#submission-tabs-5" class="primary--text">
                      Offer
                      <v-icon>attach_money</v-icon>
                    </v-tab>

                  </v-tabs>
                </div>
        
                <v-card>
                 <v-tabs-items v-model="tabs">

                  <!-- CONDITION TAB -->
                  <v-tab-item id="submission-tabs-1">
                    <v-container fluid>
                      <v-layout row wrap>
                        <v-flex sm12 md10 lg8>
                          Customer image uploads                          
                          <v-carousel v-if="submission.uploads.length>1"
                            class="mb-3 mt-2"
                            height="220"
                            hide-delimiters
                            :cycle="false"
                          >
                          
                            <v-carousel-item
                              v-for="(item,i) in submission.uploads"
                              :key="i"
                              :src="item.url"
                            >
                            <h3 style="display:inline-block;background: rgba(0,0,0,0.85);padding:0 4px;">{{ item.title }}</h3>
                            <a :href="item.url" target="_blank" 
                            style="position:absolute;content:'';width:100%;height:100%;"></a>
                            </v-carousel-item>
                          </v-carousel>

                          Rating: <span v-if="submission.ratingDescriptions">{{ submission.ratingDescriptions[submission.condition.rating] }}</span>
                            
                          
                            <v-rating 
                              class="mb-3"
                              v-model="submission.condition.rating" 
                              length="5" 
                              size="35"
                              slot="activator">
                            </v-rating>
                            
                            
                            
                            <v-textarea
                              outline
                              name="vehicle-description"
                              label="description"
                              class="mt-3"
                              auto-grow
                              rows="1"
                              v-model="submission.condition.description">
                            </v-textarea>
                             
                          
                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="submission.condition.mileage" prepend-icon="av_timer" label="Mileage" :suffix="submission.condition.mileageType"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="submission.owners" prepend-icon="people" label="Number of owners"></v-text-field>
                              </v-flex>
                            </v-layout>
                            
                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="submission.vehicle.taxExpire" prepend-icon="calendar_today" label="Tax expiry"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="submission.vehicle.nctExpire" prepend-icon="calendar_today" label="NCT expiry"></v-text-field>
                              </v-flex>
                            </v-layout>
                        
                            <v-layout row wrap class="mb-3">
                              <v-flex xs12 sm6>
                                <v-checkbox
                                  v-model="submission.condition.spareKey"
                                  label="Spare key"
                                  hide-details
                                ></v-checkbox>
                                <v-checkbox
                                  v-model="submission.condition.spareTyre"
                                  label="Spare tyre"
                                  hide-details
                                ></v-checkbox>
                                <v-checkbox
                                  v-model="submission.condition.tyresLegal"
                                  label="Tyres legal"
                                  hide-details
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm6>
                                <v-checkbox
                                  v-model="submission.condition.windscreenDamage"
                                  label="Windscreen damage"
                                  hide-details
                                ></v-checkbox>
                                <v-checkbox
                                  v-model="submission.condition.usedAsTaxi"
                                  label="Used as a taxi"
                                  hide-details
                                ></v-checkbox>
                                <v-checkbox
                                  v-model="submission.condition.financeOutstanding"
                                  label="Finance outstanding"
                                  hide-details
                                ></v-checkbox>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                 <v-menu
                                  :close-on-content-click="true"
                                  v-model="menu2"
                                  :nudge-right="40"
                                  lazy
                                  transition="scale-transition"
                                  offset-y
                                  full-width
                                  min-width="290px"
                                >
                                  <v-text-field
                                    slot="activator"
                                    v-model="submission.condition.regDate"
                                    label="Arrival Date"
                                    prepend-icon="calendar_today"
                                    readonly
                                  ></v-text-field>
                                  <v-date-picker v-model="submission.condition.regDate" @input="menu2 = false"></v-date-picker>
                                </v-menu>
                                <!-- <v-text-field v-model="submission.condition.regDate" prepend-icon="calendar_today" label="Arrival Date"></v-text-field> -->
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-select
                                  v-model="submission.condition.serviceHistory"
                                  :items="['full','partial', 'none']"
                                  label="Service History"
                                ></v-select>
                              </v-flex>
                            </v-layout>

                        </v-flex>
                      </v-layout>

                     
                    </v-container>
                  </v-tab-item>
                  <!-- /CONDITION TAB -->

                  <!-- HISTORY TAB -->
                  <v-tab-item id="submission-tabs-2">
                    <v-container fluid>
                      <v-layout column>
                        <v-flex sm12 md10 lg8>
                          <v-layout justify-center align-center pt-3>
                            <v-icon size="100" color="grey lighten-2">
                              history
                            </v-icon>
                          </v-layout>
                          <v-layout justify-center align-center pb-3>
                            <h2 class="headline">Nothing to see here yet...</h2>
                          </v-layout>
                          <v-layout justify-center align-center pb-3>
                             <v-btn
                              :loading="loading3"
                              :disabled="loading3"
                              color="blue-grey"
                              class="white--text"
                              @click.native="loader = 'loading3'"
                              large
                            >
                              Download vehicle history
                              <v-icon right dark>cloud_download</v-icon>
                            </v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-tab-item>
                  <!-- HISTORY TAB -->
                  
                  <!-- CUSTOMER TAB -->
                  <v-tab-item id="submission-tabs-3">
                    <v-container fluid>
                      <v-layout row wrap>
                        <v-flex sm12 md10 lg8>
                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="submission.firstName" prepend-icon="face" label="First Name"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="submission.surname" prepend-icon="blank" label="Surname"></v-text-field>
                              </v-flex>
                            </v-layout>
                            
                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="submission.email" prepend-icon="email" label="Email"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="submission.tel" prepend-icon="phone" label="Phone"></v-text-field>
                              </v-flex>
                            </v-layout>

                            <!-- <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="submission.county" prepend-icon="map" label="County"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="submission.postcode" prepend-icon="place" label="Eircode"></v-text-field>
                              </v-flex>
                            </v-layout> -->
                          </v-flex>
                        </v-layout>
                    </v-container>
                  </v-tab-item>
                  <!-- /CUSTOMER TAB -->

                  <!-- NOTES TAB -->
                  <v-tab-item id="submission-tabs-4">
                    <v-container fluid>
                      <v-layout row wrap>
                        <v-flex sm12 md10 lg8>
                            <v-layout row wrap>
                              <v-flex sm12>
                                <v-card id="notes" elevation="4">
                                  <v-list two-line>
                                    <template v-for="(item, index) in notes">
                                      <v-subheader
                                        v-if="item.header"
                                        :key="item.header"
                                        inset
                                      >
                                        {{ item.header }}
                                      </v-subheader>

                                      <v-divider
                                        v-if="item.divider"
                                        :key="index"
                                        inset
                                      ></v-divider>

                                      <v-list-tile
                                        :key="item.title"
                                        avatar
                                      >
                                        <v-list-tile-avatar>
                                          <img :src="item.avatar">
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>

                                          <v-expansion-panel v-if="item.content.length>120">
                                            <v-expansion-panel-content>
                                              <div slot="header" v-html="item.name"></div>
                                              <v-card>
                                                <v-card-text v-html="item.content" style="white-space: pre;"></v-card-text>
                                              </v-card>
                                            </v-expansion-panel-content>
                                          </v-expansion-panel>
                                          
                                           <v-list-tile-title v-if="item.content.length<=120" v-html="item.name"></v-list-tile-title>
                                          <v-list-tile-sub-title v-if="item.content.length<=120" v-html="item.content"></v-list-tile-sub-title>
                                          </v-list-tile-content>

                                          <v-list-tile-action>
                                            <v-list-tile-action-text v-if="item.created">{{ convertDate(item.created) }}</v-list-tile-action-text>
                                          </v-list-tile-action>
                                      </v-list-tile>
                                    </template>
                                  </v-list>
                                </v-card>

                                <form class="mt-4" @submit.prevent="onAddNote">
                                   <!-- <v-textarea v-model="newNoteContent" outline rows="1" auto-grow="true" append-outer-icon="note_add" :append-outer-icon-cb="onAddNote"></v-textarea> -->
                                  <v-textarea v-model="newNoteContent" prepend-icon="note_add" rows="1" label="Write a note" auto-grow>
                                      <v-btn slot="append-outer" type="submit" :disabled="loading" :loading="loading" fab small dark color="indigo">
                                        <v-icon dark>add</v-icon>
                                      </v-btn>
                                  </v-textarea>
                                </form>

                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                    </v-container>
                  </v-tab-item>
                  <!-- /NOTES -->

                  <!-- OFFER TAB -->
                  <v-tab-item id="submission-tabs-5">
                    <v-container fluid>
                      <v-layout row wrap>
                          <v-flex sm12 md10 lg8>
                            <v-layout row wrap>
                                  <v-list v-if="offers" two-line class="mb-4">
                                    <p class="title pl-3 pt-2">Previous Offers:</p>
                                    <template v-for="(item, key, index) in offers">
                                    
                                      
                                      <v-list-tile
                                        :key="key"
                                        avatar
                                      >
                                        <v-list-tile-avatar>
                                          <img :src="user.picUrl">
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                          <v-list-tile-title>€ {{ item.amount }}</v-list-tile-title>
                                          <v-list-tile-sub-title>{{ item.days }} days expiry from {{ convertDate(item.created) }}</v-list-tile-sub-title>
                                          
                                        </v-list-tile-content>
                                      </v-list-tile>

                                      <v-divider inset :key="index"></v-divider>
                                         
                                    </template>
                                  </v-list>
                               </v-layout>



                            <v-layout row wrap>
                              <p class="headline pl-3 pt-2">Make <span class="accent--text">{{ submission.firstName }} {{ submission.surname }}</span> an offer for this vehicle.</p>
                              <p class="pl-3">Send an offer via email & sms text to the customer that expires in <strong>7 days</strong>.<br>Any changes will be saved and the vehicle submission status will be set to <strong>Offered</strong>.</p>

                            </v-layout>

                            <form @submit.prevent="onAddOffer">
                              <v-layout row wrap>
                                  <v-flex sm12 md6>
                                    <v-text-field v-model="offerAmount" type="number" prepend-icon="money" label="Offer amount" prefix="€"></v-text-field>
                                  </v-flex>
                                  <!-- <v-flex sm12 md6>
                                    <v-text-field v-model="offerDays" disabled style="min-width: 280px;" type="number" min="1" max="30" prepend-icon="alarm" label="Offer expires in 7" suffix="Days"></v-text-field>
                                  </v-flex> -->
                                  <!-- <v-flex sm12>
                                    <p class="headline pt-2">Offer email text</p>
                                    <p>To: {{ submission.firstName }} {{ submission.surname }} &lt;{{ submission.email }}&gt;</p>
                                    <p>Hello {{ submission.firstName }}</p>
                                    <p>We are glad to offer you the sum of <span class="accent--text">{{ offerAmount }}</span> Euros for your car!</p>
                                    <p>This offer is open to you for <span class="accent--text">{{ offerDays }}</span> days. If you would like to accept this offer, click the link below before <span class="accent--text">{{ offerExpireDate }}</span> and we will be in touch to arrange a viewing with a cheque in hand.</p>
                  
                                    <v-textarea
                                          outline
                                          rows="5"
                                          v-model="offerEmailText"
                                          name="offerEmailText"
                                          label="Additional Email Text"
                                        ></v-textarea>

                                    <p><a :href="offerUrl">CLICK HERE</a> to accept our offer and arrange the viewing.</p>

                                  </v-flex> -->
                                  <v-flex sm12 md6>
                                    <v-btn class="mt-3" type="submit" :disabled="loading" :loading="loading" medium dark color="green">
                                        Make Offer
                                    </v-btn>
                  
                                  </v-flex>
                              </v-layout>
                            </form>
                          </v-flex>
                        </v-layout>
                    </v-container>
                  </v-tab-item>
                  <!-- /OFFER -->

                </v-tabs-items>
                
                <!-- /TABS -->
               
                </v-card>
              </v-flex>
            </v-layout>
            
            </v-container>
            
       
    </v-card>
    </div>
    </v-dialog>
   
    <!-- / Single submission view -->

  </v-container>
</template>

<script>

//import submissionsData from '@/assets/submissions.json'
import moment from 'moment'


export default {
  name: 'submissionsList',
  data() {
    return {
      menu2: false,
      offerAmount: '',
      offerDays: 7, // Set as default for pilot app
      offerEmailText: '',
      newNoteContent: '',
      loader: null,
      loading3: false,
      carpic: 'https://loremflickr.com/320/240/car,vehicle,2018,',
      img: '',
      tabs: 'submission-tabs-1',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      
      tempSubmissionStatus: 0,
      
      // Table Filter vars
      search: '',
      statuses: [
        { text: 'All', value: null, progress: null, icon: '',color: ''},
        { text: 'New', value: 1, progress: null, icon: 'progress', progress: 25, color: 'amber'},
        { text: 'Booked', value: 2, icon: 'progress', progress: 75, color: 'amber'},
        { text: 'Expired', value: 3, icon: 'progress', progress: 25, color: 'red'},
        { text: 'Offered', value: 4, icon: 'progress', progress: 50, color: 'amber'}, //Keep as value 4 for legacy making offer
        { text: 'Cancelled', value: 5, icon: 'progress', progress: 50, color: 'red'},
        { text: 'No Show', value: 6, icon: 'progress', progress: 50, color: 'amber'},
        { text: 'Lost', value: 7, icon: 'cancel', progress: 100, color: 'red'},
        { text: 'Won', value: 8, icon: 'progress', progress: 100, color: 'green'},
      ],
      selectedStatus: null,
      
      // View config
      submissionDialog: false,
      rowsPerPageItems: [10, 25, 50],
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'created'
      },

      // Table Cols - value = the metadata key in the json, key = the next level object in the json data 
      headers: [
        { text: 'Reg', sortable: true, key: null, value: 'reg' },
        { text: 'Make', sortable: true, key: null, value: 'make' },
        { text: 'Model', sortable: true, key: null, value: 'model' },
        { text: 'First name', sortable: true, key: null, value: 'firstName' },
        { text: 'Surname', sortable: true, key: null, value: 'surname' },
        { text: 'Tel', sortable: false, key: null, value: 'tel' },
        { text: 'Status', sortable: true, key: null, value: 'status' },
        { text: 'Last updated', sortable: true, key: null, value: 'updated' },
        { text: 'Staff member', sortable: true, key: null, value: 'user' },
        { text: 'submitted', sortable: true, key: null, value: 'created' }
      ],
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    users() {
      return this.$store.getters.users
    },
    submissionIndex() {
      return this.$store.getters.submissionIndex
    },
    submission() {
      return this.$store.getters.submission
    },
    submissions() {
      return this.$store.getters.submissions
    },
    notes() {
      return this.$store.getters.notes
    },
    offers() {
      return this.$store.getters.offers
    },
    loading() {
      return this.$store.getters.loading
    },
    filteredItems() {
      return this.$store.getters.submissions.filter((i) => {
        return !this.selectedStatus || (i.status === this.selectedStatus);
      })
    },
    offerExpireDate() {
      return this.dateFromToday(this.offerDays)
    },
    appointUrl() {
      return 'http://m4c.webeatweb.com/?appointment=' + this.submission.uid
    }
  },
  mounted: function(){
    
    //console.log(this.$store.getters.submission)
  },
  props: {
    
  },
  methods: {
    
    // SUBMISSION METHODS
    openSubmission: function(item){

      // the 'item' is the clicked on submission, find it in the main submissions data array
      let index = this.submissions.indexOf(item)
      //console.log('INDEX: ',index)
      
      // Copy the single submission from the data array to the single submission object in the store
      let payload = {}
      // make new submission obj a DEEP clone with JSON.parse that won't mutate the original
      payload.submission = JSON.parse(JSON.stringify(this.submissions[index]))
      payload.index = index
      this.$store.dispatch('setSubmission', payload)
      this.tempSubmissionStatus = this.submission.status

      // Load associated notes & offers for the submission
      this.$store.dispatch('fetchNotes', payload.submission.uid)
      this.$store.dispatch('fetchOffers', payload.submission.uid)

      // open the dialogue
      this.submissionDialog = true

    },
    closeSubmission: function() {
      this.$store.dispatch('unsetNotes', this.submission.uid)
      this.$store.dispatch('unsetOffers', this.submission.uid)
      this.$store.dispatch('unsetSubmission')
      this.submissionDialog = false
      this.tempSubmissionStatus = 0
    },
    saveSubmission: function(closeSubmission) {
      // Check if the status was changed and if so set new status
      // and add a new note

      let prevSubmissionStatus = this.submission.status

      if(this.submission.tempSubmissionStatus !== null) {
      
        this.$store.dispatch('setSubmissionStatus', this.submission.tempSubmissionStatus)

        let payload = {
          submissionUid: this.submission.uid,
          name: this.user.username,
          content: 'changed Status to ' + this.statuses[this.submission.tempSubmissionStatus].text,
          divider: true,
          avatar: this.user.picUrl
        }
        this.$store.dispatch('addNote', payload)

        if(this.submission.tempSubmissionStatus == 6) { // If No Show status was selected
            // If status changed to No Show, send the customer an email
            
            if(prevSubmissionStatus!==6) { //Check if we've sent an email last time (no change in status)
              let noShowPayload = {
                firstName: this.submission.firstName,
                surname: this.submission.surname,
                email: this.submission.email,
                appointUrl: this.appointUrl
              }
              this.$store.dispatch('noShowActivated', noShowPayload)
            }
        }


      }

      // Reset the temporary status selection?
      //this.$store.dispatch('setTempSubmissionStatus', index)
      //selectedSingleStatus = null

      this.$store.dispatch('updateSubmissionToFirebase', this.submission)
      if(closeSubmission)
        this.closeSubmission()
    },
    updateSubmissionStatus: function(index){

          this.tempSubmissionStatus = index
          // Add the component back in
          //Should just be temporary var:
          this.$store.dispatch('setTempSubmissionStatus', index)

          if(index==6) {
            alert('Selecting No Show will send the customer an email on SAVE\nAsking them to reschedule\n\nClose the submission or change status again to cancel.')
          }
     
      //Then on save, use the temporary var with setSubmissionStatus, then reset temp var
      //this.$store.dispatch('setSubmissionStatus', index)
    },

    // NOTES METHODS
    onAddNote: function() { // Only when a note is added via the chat box, addNote method adds so refactor
      if (/\S/.test(this.newNoteContent) && this.newNoteContent!==null) {
      
        // refactor below with:
        // this.addNote(this.newNoteContent)
        let payload = {
          submissionUid: this.submission.uid,
          name: this.user.username,
          content: this.newNoteContent,
          divider: true,
          avatar: this.user.picUrl
        }
        this.$store.dispatch('addNote', payload)

        //reset temp vars
        this.newNoteContent = ''
      }
    },
    addNote: function(noteContent) {
      let payload = {
          submissionUid: this.submission.uid,
          name: this.user.username,
          content: noteContent,
          divider: true,
          avatar: this.user.picUrl
        }
        this.$store.dispatch('addNote', payload)
    },

    // OFFERS METHODS
    onAddOffer: function() {
      if(this.offerAmount.length<2){
        alert('Oops, you forgot to add an Offer Amount.')
        return false;
      }
      /*
      if(this.offerDays<1 || !this.offerDays){
        alert('Oops, you forgot to specify the number of days the offer expires in.')
        return false;
      }*/
        
      let payload = {
        firstName: this.submission.firstName,
        surname: this.submission.surname,
        tel: this.submission.tel,
        email: this.submission.email,
        amount: this.offerAmount,
        reg: this.submission.reg,
        make: this.submission.make,
        model: this.submission.model,
        days: 7,
        expires: this.offerExpireDate,
        appointUrl: this.appointUrl
        //emailText: this.offerEmailText
      }
      this.$store.dispatch('addOffer', payload)
      
      //Update the status and save submission
      let offeredIndex = 4; // from statuses array
      this.updateSubmissionStatus(offeredIndex)
      this.saveSubmission(false)
      let noteHtml = 'made an offer of ' + this.offerAmount + ', expiring in 7 days.<br><br>';
      // noteHtml += 'Email sent to customer:<br>'
      // noteHtml += '<p>To: ' + payload.firstName + ' ' + payload.surname + ' &lt;' + payload.email + '&gt;</p>'
      // noteHtml += '<p>Hello ' + payload.firstName + '</p>'
      // noteHtml += '<p>We are glad to offer you the sum of ' + payload.amount + '</span> Euros for your car!</p>'
      // noteHtml += '<p>This offer is open to you for ' + payload.days + '</span> days. If you would like to accept this offer, click the link below before ' + this.offerExpireDate + '</span> and we will be in touch to arrange a viewing with a cheque in hand.</p>'
      // noteHtml += '<p>' + payload.emailText + '</p>'
      this.addNote(noteHtml)

      // reset temp offer vars
      this.offerAmount = 0
      this.offerDays = 7
      this.appointUrl = ''
      //this.offerEmailText = ''
    },

    // DATA TABLE DISPLAY METHODS
    getColumnValue(item, key, value) {
      // Handle data that is one level down in the json data using key
      let db_value = null
      if(key!==null) {
        let node = item[key]
        db_value = node[value]
      } else {
        db_value = item[value] 
      }

      // Convert any data that is in the wrong format for display
      let value_filtered = db_value
      
      if(value=='user'){
        if(db_value==0)
          value_filtered = '. . .'
        else
          value_filtered =  this.users[db_value].username
      }

      if(value=='status'){
        value_filtered = this.statuses[db_value].text
      }

      if(value=='created' || value=='updated')
        value_filtered = this.convertDate(db_value)

      return value_filtered

    },
    convertDate: function(timestamp) {
      return moment(timestamp).format('DD/MM/YYYY ~ HH:mm')
      /*
      let date = new Date(timestamp);
      let day = ('0' + date.getDate()).slice(-2)
      let month = ('0' + parseInt(date.getMonth())+1).slice(-2)
      let yr = date.getFullYear()
      let hrs = ('0' + date.getHours()).slice(-2)
      let mins = ('0' + date.getMinutes()).slice(-2)
      let secs = ('0' + date.getSeconds()).slice(-2)
      return day + '/' + month + '/' + yr + ' - ' + hrs + ':' + mins + ':' + secs*/
    },
    dateFromToday: function(numOfDays) {
      /*
      let theDate = new Date();
      
      theDate.setDate(parseInt(theDate.getDate() + numOfDays))
      let formattedDate = (theDate.getDate() + "/" + (theDate.getMonth()) + "/" + theDate.getFullYear());
      return formattedDate;
      */
      return moment().add(numOfDays, 'days').format('DD/MM/YYYY')
    },
    scrollNotesToBottom: function() {
      setTimeout(function(){
        let notesCard = document.getElementById('notes')
        notesCard.scrollTop = notesCard.scrollHeight
      }, 600)
    },
    submissionUsername: function() {
       
      if(this.submission.user==0) {
        return false
      } else {
        return this.users[this.submission.user].username
      }
    },
    /*
    getCarImage: function(make){
      var apiKey = 'AIzaSyDzvYjtT7MKS8z59-4ZgSx59YrEnJIsdwQ';
      var cx = '000802721154775260942:hpzttaoa3eu'; 
      var fType = 'png%2C+gif%2C+jpg';
      var imageSize = 'small';
      //var imgDominantColor = 'black';
      var endpointURL = 'https://www.googleapis.com/customsearch/v1?';
      var q = make+' vehicle car 2018';
      var num = 1;
      var requestURL = endpointURL + 'q=' + q + '&fileType=' + fType + '&imgSize=' + imageSize + '&cx=' + cx + '&key=' + apiKey + '&num=' + num;
      var that = this;
      fetch(requestURL, {
        method: 'get'
      })
      .then(
        function(response) {
          if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }

          //console.log(response)
          // Examine the text in the response
          response.json().then(function(data) {
            //console.log(JSON.stringify(data));
            
             var items = data.items;
             var imageURL = '';
            items.forEach( function(item){
              imageURL = item.pagemap.cse_image[0].src;
            });
            that.img = imageURL;
          });
        }
      ) 
      .catch(function(err) {
        console.log('Fetch Error :-S', err);
      });



    }*/

    /*
    moment: function (date) {
      return moment(date);
    }*/
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
    tabs() {
      if(this.tabs=='submission-tabs-4')
        this.scrollNotesToBottom()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.submissions-data-table td{
  cursor: pointer;
}

.dialogue-back{
  background-color: #F2F2F2;
}

.theme--dark.dialogue-back{
  background-color: #333;
}

.v-content__wrap{
  /*
  background-color: #F2F2F2;*/
}

.theme--dark.v-content__wrap{
  background-color: #333;
}

/* experiment */
.hoverdesc > .v-icon:nth-child(1):hover:after{
  position: absolute;
  content: "Hi Im the description...";
  top: 30px;
  background: yellow;
  color: black;
  padding: 10px;

}


#notes{

  max-height: 500px;
  
  overflow-y: scroll;
}

#notes .v-list--two-line .v-list__tile,
#notes .v-list__tile .v-list__tile--avatar{
  padding-top: 12px;
  padding-bottom: 12px;
  height: auto!important;
}

#notes .v-expansion-panel__header{
  padding: 0;
}
</style>
